import { Box, Button, Modal, Typography } from "@mui/material";
import React from "react";
import { modalStyle } from "../../../../../components/modalStyle";
import NoAccountsOutlinedIcon from "@mui/icons-material/NoAccountsOutlined";

export default function DeleteModal({
  openModal,
  setOpenModal,
  row,
  onInactivate,
}) {
  const handleClose = () => setOpenModal(false);

  const handleInactivate = async () => {
    onInactivate(row);
    handleClose();
  };

  return (
    <Modal open={openModal} onClose={handleClose}>
      <Box sx={{ ...modalStyle, width: 600 }}>
        <Box sx={{ mb: 2, textAlign: "center" }}>
          <NoAccountsOutlinedIcon sx={{ color: "red", fontSize: 140 }} />
        </Box>
        <Typography id="modal-modal-title" variant="h6" component="h2">
          Are you sure you want to inactivate ({row?.name})?
        </Typography>
        <Typography id="modal-modal-description" sx={{ mt: 2 }}>
          By inactivating this user, you will disable their access to the system
          and all associated data. This action cannot be undone.
        </Typography>

        <Box sx={{ float: "right", mt: 3, gap: 2, display: "flex" }}>
          <Button variant="outlined" color="error" onClick={handleClose}>
            Cancel
          </Button>
          <Button variant="contained" color="error" onClick={handleInactivate}>
            Inactivate
          </Button>
        </Box>
      </Box>
    </Modal>
  );
}
